// Notice (truck stock, BL-203): one short block that says what waits on someone or what was just done,
// in words, with its actions. Waiting is DESIGN.md §2's waiting drawing at an area's size: dashed all
// round on the paper grid's shade (a count that arrived and waits to be posted; "Your count is with the
// office"). Done is the ink mark down its start and what changed, said once ("Posted at 11:20 a.m.: …");
// it is a status, so a screen reader hears it, and it can take the focus as it appears, so the keyboard
// lands where the work ended. Never red (a problem is the field's own red line), never a box with a fill.
// Reads only --notice-*.
// New (Components): ui-web had no block notice; RecordPage's is a one-line slot of that pattern, and
// the tech kit's Notice is React Native.
import { useEffect, useRef, type ReactNode } from 'react';
import './Notice.css';

export interface NoticeProps {
  /** waiting: dashed, it waits on someone; done: what was just done, the ink mark at its start. */
  tone?: 'waiting' | 'done';
  /** Its first line, strong: "Sam’s count arrived, 10:52 a.m.". */
  title: ReactNode;
  /** The muted words under it. */
  children?: ReactNode;
  /** Its actions: one Button at most, then Links. */
  actions?: ReactNode;
  /** Takes the focus as it appears (a done notice after Post), so the keyboard lands on what changed. */
  takesFocus?: boolean;
  id?: string;
}

export function Notice({ tone = 'waiting', title, children, actions, takesFocus, id }: NoticeProps) {
  const box = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (takesFocus) box.current?.focus();
  }, [takesFocus]);
  return (
    <div
      ref={box}
      id={id}
      className="fl-notice"
      data-tone={tone}
      role={tone === 'done' ? 'status' : undefined}
      tabIndex={takesFocus ? -1 : undefined}
    >
      <p className="fl-notice__title">{title}</p>
      {children != null ? <div className="fl-notice__words">{children}</div> : null}
      {actions != null ? <div className="fl-notice__acts">{actions}</div> : null}
    </div>
  );
}
